// Classnames
import classNames from 'classnames'

// Icons
import {
    IconAlertSquareRoundedFilled,
    IconAlertTriangleFilled,
    IconCircleCheckFilled,
    IconInfoOctagonFilled,
} from '@tabler/icons-react'

export default function Banner({
    children,
    title,
    type = 'info',
    compact = false,
    fixedHeight = false,
}) {
    const classes = classNames(
        'border rounded-xl flex flex-col justify-center',
        compact ? 'p-3 gap-1' : 'p-5 md:p-8 gap-2',
        fixedHeight && (compact ? 'h-[75px]' : 'h-[140px]'),
        'text-gray-700',
        {
            'bg-red-50/50 border-red-200': type === 'error',
            'bg-green-50/50 border-green-300': type === 'success',
            'bg-blue-50/50 border-blue-200': type === 'info',
            'bg-orange-50/50 border-orange-200': type === 'warning',
        }
    )

    const iconColorClass = {
        error: 'text-red-500',
        success: 'text-green-500',
        info: 'text-blue-500',
        warning: 'text-orange-500',
    }[type]

    const iconSize = compact ? 18 : 30

    return (
        <div className={classes}>
            <div className="flex items-start justify-between">
                <span
                    className={classNames(
                        compact
                            ? 'text-sm font-medium'
                            : 'md:text-lg font-medium',
                        iconColorClass
                    )}
                >
                    {title}
                </span>

                <span className={iconColorClass}>
                    {type === 'error' && (
                        <IconAlertSquareRoundedFilled
                            size={iconSize}
                            stroke={1}
                        />
                    )}

                    {type === 'success' && (
                        <IconCircleCheckFilled size={iconSize} stroke={1} />
                    )}

                    {type === 'info' && (
                        <IconInfoOctagonFilled size={iconSize} stroke={1} />
                    )}

                    {type === 'warning' && (
                        <IconAlertTriangleFilled size={iconSize} stroke={1} />
                    )}
                </span>
            </div>

            {children && (
                <div
                    className={classNames(iconColorClass, compact && 'text-sm')}
                >
                    {children}
                </div>
            )}
        </div>
    )
}
